export default "__VITE_ASSET__327ad3d6__"